
import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { ContactHeroImg } from "../../theme/images";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  Label,
  FormGroup,
} from "reactstrap";
import {
  FiMail,
  FiPhone,
  FiClock,
  FiArrowRight,
  FiLinkedin,
  // FiTwitter,
  FiGlobe,
  FiHeadphones,
  FiUsers,
  FiMessageCircle,
  FiCheckCircle,
} from "react-icons/fi";
import { Favicon } from "../../theme/images";
import { useLocation } from "react-router-dom";
import "./Contact.css";
import { submitContactForm } from "../../services/api";
import { toast } from "react-toastify";
const inquiryTypes = [
  { id: "general", label: "General Inquiry", icon: FiMessageCircle },
  { id: "services", label: "Our Services", icon: FiUsers },
  { id: "partnership", label: "Partnership", icon: FiGlobe },
  { id: "support", label: "Technical Support", icon: FiHeadphones },
];

// Add this data inside your Contact component
const locations = [
  {
    country: "India",
    title: "Pune Head Office",
    branch: "Head Office",
    company: "SpringUp Labs",
    logo: { Favicon },
    hasWebsite: false,
    address: "I2I building, Pallod Farms, Lane-3, near Vijay Sales, Baner, Pune - 411045"
  },
  {
    country: "India",
    title: "Chennai Branch Office",
    branch: "Branch Office",
    company: "SpringUp Labs",
    logo: "./asset/img/logo-1-_1_ 2.png",
    hasWebsite: false,
    address: "Cactus Corporate Coworking, 6th Floor, Block B, Tecci Park, OMR, Sholinganallur, Chennai - 600119"
  },
  {
    country: "United Arab Emirates (UAE)",
    title: "SpringUp Labs UAE",
    company: "SpringUp Labs UAE",
    logo: "./asset/img/logo-1-_1_ 2.png",
    hasWebsite: false,
    address: "Compass Bldg, Al Shohada Rd, Al Hamra IFZ, Ras al Khaima (UAE)",
    contact: "+971 50 265 9676"
  },
  {
    country: "United Kingdom",
    title: "SpringUp Labs UK",
    website: "https://springuplabs.uk/",
    company: "SpringUp Labs UK",
    logo: "./asset/img/logo-1-_1_ 2.png",
    hasWebsite: true
  },
  {
    country: "Norway",
    title: "SpringUp Labs Norway",
    website: "https://springuplabs.no/",
    company: "SpringUp Labs Norway",
    logo: "./asset/img/logo-1-_1_ 2.png",
    hasWebsite: true
  },
  {
    country: "Germany",
    title: "SpringUp Labs Germany",
    website: "https://springuplabs.de/",
    company: "SpringUp Labs Germany",
    logo: "./asset/img/logo-1-_1_ 2.png",
    hasWebsite: true
  }

];

// const stats = [
//   { value: "100+", label: "Projects Delivered" },
//   { value: "50+", label: "Happy Clients" },
//   { value: "24h", label: "Avg Response" },
//   { value: "15+", label: "Countries" },
// ];

const Contact = () => {
  const location = useLocation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});
  const [activeInquiry, setActiveInquiry] = useState("general");
  const SITE_KEY = "6LdwLKctAAAAADh7ERJ0Op37vXPJGH-d71bUsnwj";
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    phone: "",
    company_name: "",
    subject: "",
    message: "",
  });


  const validateForm = () => {
    const newErrors = {};

    if (!formData.full_name.trim()) newErrors.full_name = "Full name is required";
    if (!formData.email.trim()) newErrors.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = "Please enter a valid email";
    if (!formData.company_name.trim()) newErrors.company_name = "Company name is required";
    if (!formData.message.trim()) newErrors.message = "Message is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    // setFormData((prev) => ({ ...prev, [name]: value }));
    // Allow only numbers for phone field
    if (name === "phone") {
      const onlyNumbers = value.replace(/\D/g, "");

      // Maximum 10 digits
      if (onlyNumbers.length > 10) return;

      setFormData((prev) => ({
        ...prev,
        [name]: onlyNumbers,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      toast.error("Please fill all required fields correctly.");
      return;
    }

    setIsSubmitting(true);

    try {

      // 1. Get reCAPTCHA v3 token
      const token = await new Promise((resolve, reject) => {
        if (!window.grecaptcha) {
          reject(new Error("reCAPTCHA not loaded. Please refresh the page."));
          return;
        }

        window.grecaptcha.ready(() => {
          window.grecaptcha
            .execute(SITE_KEY, { action: "contact_form" })
            .then((token) => resolve(token))
            .catch((err) => reject(err));
        });
      });
      // 2. Send form data + captcha token
      const response = await submitContactForm({
        ...formData,
        captchaToken: token,
      });

      if (response.success) {
        toast.success(response.message || "Your message has been sent successfully!");

        // Reset form
        setFormData({
          full_name: "",
          email: "",
          phone: "",
          company_name: "",
          subject: "",
          message: "",
        });
        setErrors({});
      }
    } catch (error) {
      toast.error(error.message || "Failed to send message. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    // Load reCAPTCHA script only once
    if (!document.getElementById("recaptcha-script")) {
      const script = document.createElement("script");
      script.id = "recaptcha-script";
      script.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);


  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const element = document.getElementById(id);

      if (element) {
        setTimeout(() => {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }, 300); // Small delay to let page load
      }
    }
  }, [location.hash]);

  return (
    <div className="contact-page min-vh-100 bg-light">
      {/* HERO SECTION - Exact as per your original code */}
      <section className="contact-hero position-relative overflow-hidden border-bottom bg-white py-3 ">
        {/* Subtle pattern */}
        <div
          className="contact-hero-pattern position-absolute top-0 start-0 w-100 h-100"
          style={{
            backgroundImage: "radial-gradient(hsl(153, 62%, 44%) 1px, transparent 1px)",
            backgroundSize: "28px 28px",
            opacity: "0.03",
          }}
        />

        <Container className="position-relative">
          <Row className="align-items-center g-5">
            {/* Left — Text */}
            <Col lg={6}>
              <motion.div
                initial={{ opacity: 0, x: -40 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
              >
                <span pill className="contact-hero-badge mb-4 px-4 py-2">
                  <FiMail size={16} className="me-2" /> Contact Us
                </span>

                <h1 className="contact-hero-title fw-bold mb-4">
                  Connect With Our Experts<br />
                  <span className="contact-highlight">To Transform Your Business</span>
                </h1>

                <p className="contact-hero-subtitle lead mb-5">
                  We help businesses build, scale, and innovate through modern digital engineering, delivering value-driven and customer-focused solutions.
                </p>

                {/* Mini Stats */}
                {/* <div className="contact-stats d-flex flex-wrap gap-5">
                  {stats.map((s, i) => (
                    <motion.div
                      key={i}
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: 0.4 + i * 0.1 }}
                      className="text-center text-md-start"
                    >
                      <div className="contact-stat-value fw-bold">{s.value}</div>
                      <div className="contact-stat-label">{s.label}</div>
                    </motion.div>
                  ))}
                </div> */}
              </motion.div>
            </Col>

            {/* Right — Illustration */}
            <Col lg={6}>
              <motion.div
                initial={{ opacity: 0, scale: 0.92 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.8, delay: 0.2 }}
                className="text-center"
              >
                <div className="contact-hero-image-wrapper position-relative">
                  <div className="contact-hero-image-glow" />
                  <img
                    src={ContactHeroImg}
                    alt="IT team collaboration"
                    className="contact-hero-image img-fluid"
                  />
                </div>
              </motion.div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* MAIN CONTACT SECTION - Attractive & Fully Animated */}
      <Container className="py-5 py-lg-6">
        <Row className="g-5">
          {/* Form Area - Left Side */}
          <Col lg={8}>
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
            >
              <h2 className="contact-main-title fw-bold mb-2">How Can We Help?</h2>
              <p className="contact-main-subtitle text-muted mb-5">
                Select your inquiry type and fill in the details below.
              </p>
            </motion.div>

            {/* Inquiry Type Tabs - Animated */}
            <motion.div
              className="contact-inquiry-tabs d-flex flex-wrap gap-3 mb-5"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
            >
              {inquiryTypes.map((type, index) => {
                const Icon = type.icon;
                const isActive = activeInquiry === type.id;
                return (
                  <motion.button
                    key={type.id}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.96 }}
                    onClick={() => setActiveInquiry(type.id)}
                    className={`contact-inquiry-btn d-flex align-items-center gap-3 px-5 py-3 rounded-pill border-0 fw-medium ${isActive ? 'active' : ''}`}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.1 + index * 0.08 }}
                  >
                    <Icon size={20} />
                    {type.label}
                  </motion.button>
                );
              })}
            </motion.div>

            {/* Form Card */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
            >
              <Card className="contact-form-card border-0 shadow">
                <CardBody className="p-4 p-lg-5">
                  <form onSubmit={handleSubmit}>
                    <Row className="g-4">
                      <Col md={6}>
                        <FormGroup className="contact-form-group">
                          <Label className="contact-form-label">Full Name *</Label>
                          <Input
                            name="full_name"
                            placeholder="Enter your full name"
                            value={formData.full_name}
                            onChange={handleChange}
                            invalid={!!errors.full_name}
                            className="contact-input"
                          />
                          {errors.full_name && <small className="text-danger">{errors.full_name}</small>}
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup className="contact-form-group">
                          <Label className="contact-form-label">Business Email *</Label>
                          <Input
                            type="email"
                            name="email"
                            placeholder="Enter your email"
                            value={formData.email}
                            onChange={handleChange}
                            invalid={!!errors.email}
                            className="contact-input"
                          />
                          {errors.email && <small className="text-danger">{errors.email}</small>}
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup className="contact-form-group">
                          <Label className="contact-form-label">Phone Number</Label>
                          <Input
                            name="phone"
                            placeholder="e.g.  XXXXX XXXXX"
                            value={formData.phone}
                            onChange={handleChange}
                            className="contact-input"
                            inputMode="numeric"
                            maxLength={10}
                          />
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup className="contact-form-group">
                          <Label className="contact-form-label">Company / Organization *</Label>
                          <Input
                            name="company_name"
                            placeholder="Enter Your Company"
                            value={formData.company_name}
                            onChange={handleChange}
                            invalid={!!errors.company_name}
                            className="contact-input"
                          />
                          {errors.company_name && <small className="text-danger">{errors.company_name}</small>}
                        </FormGroup>
                      </Col>
                    </Row>

                    <FormGroup className="mt-4 contact-form-group">
                      <Label className="contact-form-label">Subject</Label>
                      <Input
                        name="subject"
                        placeholder="What's this about?"
                        value={formData.subject}
                        onChange={handleChange}
                        className="contact-input"
                      />
                    </FormGroup>

                    <FormGroup className="mt-4 contact-form-group">
                      <Label className="contact-form-label">How can we help? *</Label>
                      <Input
                        type="textarea"
                        name="message"
                        rows="6"
                        placeholder="Tell us about your project, goals, and timeline..."
                        value={formData.message}
                        onChange={handleChange}
                        invalid={!!errors.message}
                        className="contact-textarea"
                      />
                      {errors.message && <small className="text-danger">{errors.message}</small>}
                    </FormGroup>

                    <div className="d-flex flex-column flex-sm-row gap-3 align-items-center mt-5 pt-4 border-top">
                      <Button
                        type="submit"
                        color="primary"
                        className="contact-submit-btn px-5 py-3 fw-semibold"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? "Sending..." : "Submit Inquiry"}
                      </Button>
                      <p className="text-muted small mb-0">
                        We typically respond within 24 business hours.
                      </p>
                    </div>
                    {/* Add this small note */}
                    {/* <p className="text-muted small mt-3 mb-0">
                        This site is protected by reCAPTCHA and the Google{" "}
                        <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">
                          Privacy Policy
                        </a>{" "}
                        and{" "}
                        <a href="https://policies.google.com/terms" target="_blank" rel="noreferrer">
                          Terms of Service
                        </a>{" "}
                        apply.
                      </p> */}
                  </form>
                </CardBody>
              </Card>
            </motion.div>
          </Col>

          {/* Sidebar - Right Side */}
          <Col lg={4}>
            <div className="contact-sidebar sticky-top" style={{ top: "100px" }}>
              {/* Contact Info Card */}
              <motion.div
                initial={{ opacity: 0, x: 30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.4 }}
              >
                <Card className="contact-sidebar-card mb-4 border-0 shadow-sm">
                  <CardBody className="p-4">
                    <h5 className="contact-sidebar-title mb-4">Reach Us Directly</h5>
                    <div className="contact-info-list">
                      {[
                        { icon: FiMail, label: "Email", value: "info@springuplabs.com" },
                        { icon: FiPhone, label: "Phone", value: " +91 92095 54382" },
                        { icon: FiClock, label: "Working Hours", value: "Mon – Fri, 10 AM – 7 PM IST" },
                      ].map((item, i) => (
                        <div key={i} className="contact-info-item">
                          <div className="contact-info-icon-wrapper">
                            <item.icon size={22} />
                          </div>
                          <div>
                            <small className="contact-info-label">{item.label}</small>
                            <div className="contact-info-value">{item.value}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </CardBody>
                </Card>
              </motion.div>

              {/* Why Choose Us */}
              <motion.div
                initial={{ opacity: 0, x: 30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.5 }}
              >
                <Card className="contact-why-card mb-4 border-0 shadow-sm">
                  <CardBody className="p-4">
                    <h5 className="contact-sidebar-title mb-4">Why SpringUp Labs?</h5>
                    <div className="contact-why-list">
                      {[
                        "Dedicated offshore development teams",
                        "AI-first approach to engineering",
                        "Transparent & agile process",
                        "Post-launch support included",
                        "ISO 27001 certified",
                      ].map((item, i) => (
                        <div key={i} className="contact-why-item">
                          <FiCheckCircle className="text-success me-3" size={20} />
                          <span>{item}</span>
                        </div>
                      ))}
                    </div>
                  </CardBody>
                </Card>
              </motion.div>

              {/* Social Links */}
              <motion.div
                initial={{ opacity: 0, x: 30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.6 }}
              >
                <Card className="contact-social-card border-0 shadow-sm">
                  <CardBody className="p-4">
                    <h5 className="contact-sidebar-title mb-4">Follow Us</h5>
                    <div className="d-flex gap-3">
                      {[
                        { icon: FiLinkedin, label: "LinkedIn", href: "https://www.linkedin.com/company/springup-labs/posts/" },
                        // { icon: FiTwitter, label: "Twitter", href: "https://twitter.com/" },
                        // { icon: FiGlobe, label: "Website", href: "https://www.springuplabs.com" },
                      ].map((s, i) => (
                        <Button
                          key={i}
                          href={s.href}
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label={s.label}
                          color="light"
                          className="contact-social-btn d-flex align-items-center justify-content-center rounded-circle"
                        >
                          <s.icon size={22} />
                        </Button>
                      ))}
                    </div>
                  </CardBody>
                </Card>
              </motion.div>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Global Offices - Modern Attractive Design */}
      <section className="contact-offices-section py-5 py-lg-6 bg-white border-top" id="global-offices" >
        <Container>
          <div className="text-center mb-5">
            <span color="primary" pill className="contact-offices-badge mb-3 px-4 py-2">
              <FiGlobe className="me-2" /> Our Offices
            </span>
            <h2 className="contact-section-title fw-bold mb-3">Global Presence</h2>
            <p className="text-muted contact-offices-subtitle">
              With offices across multiple continents, we're always close to you.
            </p>
          </div>

          <Row className="g-4">
            {locations.map((office, index) => (
              <Col md={6} lg={4} key={index}>
                <motion.div
                  initial={{ opacity: 0, y: 50, scale: 0.92 }}
                  whileInView={{ opacity: 1, y: 0, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.7, delay: index * 0.08 }}
                  whileHover={{ y: -12, scale: 1.03 }}
                  className="contact-office-card h-100"
                >
                  <div className="contact-office-header">
                    <div className="d-flex align-items-center justify-content-between w-100">
                      <h4 className="contact-office-title mb-0">
                        <span className="contact-office-flag me-3">{office.country === "India" ? "🇮🇳" :
                          office.country === "United Kingdom" ? "🇬🇧" :
                            office.country === "Norway" ? "🇳🇴" :
                              office.country === "Germany" ? "🇩🇪" : "🇦🇪"}</span>
                        {office.title}
                      </h4>
                      <FiGlobe size={22} className="contact-office-map-icon" />
                    </div>
                  </div>

                  <div className="contact-office-body">
                    <div className="website-badge d-flex align-items-center gap-3 mb-4">
                      <img
                        src={Favicon}
                        alt={office.company}
                        className="contact-office-logo"
                      />
                      <span className="contact-office-company">{office.company}</span>
                    </div>

                    {office.address && (
                      <div className="contact-office-address-wrapper">
                        <strong className="contact-office-address-label">Location :</strong>
                        <p className="contact-office-address">
                          {office.address}
                        </p>
                      </div>
                    )}

                    {office.contact && (
                      <div className="contact-office-contact mt-3">
                        <FiPhone className="me-2" /> {office.contact}
                      </div>
                    )}

                    {office.hasWebsite && office.website && (
                      <a
                        href={office.website}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="contact-office-website-btn mt-4 d-inline-flex align-items-center gap-2"
                      >
                        Visit Website <FiArrowRight size={16} />
                      </a>
                    )}
                  </div>
                </motion.div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Contact;